// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2FnEb","colMin":"styles_colMin__38bzE","colCheckbox":"styles_colCheckbox__1PqYp"};